module.exports = __webpack_public_path__ + "static/media/invitedFriends_25_50.e2f2fa7c.png";